require('./cardsBoxHeaderTravelToggle.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
// @ commons
const OKModal = require('components/commons/OKModal/OKModal');
// @ utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
//@constants
const { DATE_FORMAT_FULL_MONTH_YEAR } = require('constants/index');
//@actions
const { switchCardTravelOn, switchCardTravelOff, resetCardTravel } = require('actions/cardTravel');
const CardsToggleButton = require('components/cards/cardsToggleButton/cardsToggleButton');
class CardsBoxHeaderTravelToggle extends React.Component {

    constructor(props) {
        super(props);
    }
    buildElements() {

    }
    buildModalContent() {
        const { immCard } = this.props;
        const onCloseCallback = this.handleToggleModal;
        let primaryButtonDisabled = false;
        let content, titleLabel;
        let primaryButtonText;
        let primaryButtonCallback;
        let footerType;
        let title;
        const untilDate = immCard.getIn(['r42', 'promotionDate']);
        const isDateEnabled = immCard.getIn(['r42', 'enabledPromotionDate']);
        const elements =
            [
                {
                    icon:'icon-comercio-tiendas',
                    title:'cardsTravel-modal_freeComissionsTitle',
                    description:'cardsTravel-modal_freeComissionDescription'
                },
                {
                    icon:'icon-cajero',
                    title:'cardsTravel-modal_freeCashTitle',
                    description:'cardsTravel-modal_freeCashDescription'
                },
                {
                    icon:'icon-seguro-accidentes',
                    title:'cardsTravel-modal_freeSafeTitle',
                    description:'cardsTravel-modal_freeSafeDescription'
                },
                {
                    icon:'icon-diversificacion',
                    title:'cardsTravel-modal_freeConversionTitle',
                    description:'cardsTravel-modal_freeConversionDescription'
                }
            ];
        const elementsView = elements.map((element, ind) => {
            return (
                <div key={ind} className="cards-travel-toggle__modal-content__main__element">
                    <div className="cards-travel-toggle__modal-content__main__element-left">
                        <div className="cards-travel-toggle__modal-content__main__element-left-icon">
                            <i className={element.icon}/>
                        </div>
                    </div>
                    <div className="cards-travel-toggle__modal-content__main__element-right">
                        <div className="cards-travel-toggle__modal-content__main__element-right-top">
                            <FormattedText value={element.title}/>
                        </div>
                        <div className="cards-travel-toggle__modal-content__main__element-right-bottom">
                            <FormattedText value={element.description}/>
                        </div>
                    </div>
                </div>
            )
        });

        const dueDateBlock = !!untilDate && isDateEnabled && 
            (
                <div className="cards-travel-toggle__modal-content__price-bottom-until">
                    <FormattedText value="cardsTravel-modal_price_until"/>
                    <span> {DateHelper.formatDate(untilDate, DATE_FORMAT_FULL_MONTH_YEAR).toLowerCase()}</span>
                </div>
            ) ;

        const priceView = (
            <div className="cards-travel-toggle__modal-content__price">
                <div className="cards-travel-toggle__modal-content__price-middle"></div>
                <div className="cards-travel-toggle__modal-content__price-bottom">
                    {dueDateBlock}
                </div>
                <div className="cards-travel-toggle__modal-content__price-info">
                    <div className="cards-travel-toggle__modal-content__price-info-free">
                        <FormattedText value="cardsTravel-modal_price_free"/>
                    </div>
                </div>
            </div>
        )

        titleLabel = 'cardsTravel-modal_title';
        primaryButtonText = 'cardsTravel-modal_agree';
        primaryButtonCallback = this.handleToggleModal;

        footerType = 'navigation';
        title = formatText(titleLabel);

        content = (
            <div className="cards-travel-toggle__modal-content">
                <h3 className="ok-modal__title ok-modal__title--center">{title}</h3>
                <div className="cards-travel-toggle__modal-content__subtitle">
                    <span>
                        <FormattedText value="cardsTravel-modal_subtitle"/> { !!untilDate && isDateEnabled && DateHelper.formatDate(untilDate, DATE_FORMAT_FULL_MONTH_YEAR).toLowerCase()}
                    </span>
                </div>
                <div className="cards-travel-toggle__modal-content__main">
                    {elementsView}
                </div>
                {priceView}
                <div className="cards-travel-toggle__modal-content__footer">
                    <FormattedText value="cardsTravel-modal_termsConditions"/>
                </div>
            </div>
        )

        return (
            <OKModal
                className={'cardsTravel-toggle-OkModal'}
                content={content}
                footerType={footerType}
                isOpen={this.state.modalOpen}
                onCloseCallback={onCloseCallback}
                onPrimaryButtonClick={primaryButtonCallback}
                primaryButtonDisabled={primaryButtonDisabled}
                primaryButtonText={primaryButtonText}
                shouldCloseOnOverlayClick={false}
                titleAlignment={'center'}
                overlayClassName={'ok-modal-travel-overlay'}
            />
        );
    }

    render() {
        const { immCard } = this.props;

        return (
            <div className="cards-travel-toggle">
                <CardsToggleButton
                    buildModalContent={this.buildModalContent}
                    tooltipOff={'cardsTravel-offTooltip'}
                    tooltipOnSubmit={'cardsTravel-onSubmit'}
                    reducerStateName={'cardTravelOn'}
                    immCard={immCard}
                    cardFieldCheck={'r42Activated'}
                    description={'cardsTravel-toggle_description'}
                    resetCardToggle={this.props.resetCardTravel}
                    switchCardToggleOff={this.props.switchCardTravelOff}
                    switchCardToggleOn={this.props.switchCardTravelOn}
                />
            </div>
        );
    }
}

CardsBoxHeaderTravelToggle.propTypes = {
    immCard: PropTypes.object.isRequired,
    resetCardTravel: PropTypes.func.isRequired,
    switchCardTravelOff: PropTypes.func.isRequired,
    switchCardTravelOn: PropTypes.func.isRequired
}


const mapDispatchToProps = {
    resetCardTravel,
    switchCardTravelOff,
    switchCardTravelOn
};

module.exports.constructor = CardsBoxHeaderTravelToggle;
module.exports.CardsBoxHeaderTravelToggle = connect(null, mapDispatchToProps)(CardsBoxHeaderTravelToggle);

